// import { LOADER_STATUS } from '../constants';
import { FILE_DATA, SET_COMPARATIVE_TABLE_DATA } from './constants';    
import { LOADER_STATUS, STORE_PERIOD } from './constants';
import { SET_PREVIEW_TABLE_DATA , } from './constants';

export const initialState = {
    loaderStatus: false,
    startDate: null,
    endDate: null,
    previewTableData: [],
    fileData: [],
    comparativeTableData: []
};

const gstr2xSaveReducer = (state=initialState, action) => {
  switch(action.type){
    case LOADER_STATUS : {
        return {
            ...state,
            loaderStatus: action.loaderStatus
        }
    }
    case FILE_DATA:
      return {
        ...state,
        fileData:action.fileData
      }
    case STORE_PERIOD:
        return {
          ...state,
          startDate:action.date.startDate,
          endDate: action.date.endDate
        } 
    case SET_PREVIEW_TABLE_DATA:
        return {
          ...state,
          previewTableData: action.payload
        } 
        case SET_COMPARATIVE_TABLE_DATA:
        return {
          ...state,
          comparativeTableData: action.payload
        } 
    default: return state;
  }
}

export default gstr2xSaveReducer